import Swiper from 'swiper';
import { Pagination, Keyboard, Autoplay } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function(){

    // breakpoint to watch enable / disable swiper at
    const breakpoint = window.matchMedia('(min-width:992px)');

    // global scope swiper variable
    let CareerCarouselSwiper;

    // init carousel
    const initCarousel = () => {
        const carouselEl = document.querySelector('.career-swiper');

        CareerCarouselSwiper = new Swiper(carouselEl, {
            modules: [Pagination, Keyboard, Autoplay],
            loop: true,
            spaceBetween: 50,
            keyboard: {
                enabled: true
            },
            autoplay: {
                delay: 6000,
                pauseOnMouseEnter: true
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            on: {
                'afterInit': function(swiper){
                    // stop on load
                    swiper.autoplay.stop();
                }
            }
        });

        // observe for carousel
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if ( entry.isIntersecting && entry.intersectionRatio >= 0.5 ){
                    // play when scroll on
                    CareerCarouselSwiper?.autoplay?.start();
                }
                else
                {
                    // pause when scroll off
                    CareerCarouselSwiper?.autoplay?.stop();
                }
            });
        }, 
        {
            threshold: 0.5
        });

        observer.observe(carouselEl);
    }

    // show more mobile index
    let showMoreMobileIndex = 0;

    const showNextMobileSlide = (scrollToNext = false) => {
        const loadMoreWrapper = document.querySelector('.career-swiper .load-more');
        const allSlides = document.querySelectorAll('.career-swiper .swiper-slide');

        // show slide according to index
        allSlides[showMoreMobileIndex].classList.add('visible-mobile');

        // scroll to newly shown index
        if ( scrollToNext ) {
            window.scrollTo({
                top: allSlides[showMoreMobileIndex].getBoundingClientRect().top + window.scrollY - (document.querySelector('#main-header').getBoundingClientRect().height + 50), 
                behavior: 'smooth'
            });
        }

        // if all slides are visible, hide button and return
        if ( allSlides.length - 1 === showMoreMobileIndex ) {
            loadMoreWrapper.classList.add('d-none');
            return;
        }

        // increment index
        showMoreMobileIndex++;
    };

    const breakpointChecker = () => {
        // check if breakpoint matches, if so, enable carousel
        if ( breakpoint.matches ) {
            initCarousel();
            return;
        }

        // if it doesn't and carousel is initted, disable it
        if ( CareerCarouselSwiper !== undefined ) CareerCarouselSwiper.destroy( true, true );
        showNextMobileSlide();

        return;
     };

    // track selected breakpoint changes
    breakpoint.addEventListener('change', breakpointChecker);

    // start breakpoint check on load
    breakpointChecker();

    // handle click on "show more" button on mobile
     const loadMoreButton = document.querySelector('.career-swiper .load-more__button');
     loadMoreButton.addEventListener('click', function(e){
        e.preventDefault();

        // disable button
        loadMoreButton.setAttribute('disabled', true);
        loadMoreButton.classList.add('isLoading');

        // show next slide
        showNextMobileSlide(true);

        // enable button
        loadMoreButton.removeAttribute('disabled');
        loadMoreButton.classList.remove('isLoading');
     });
});